import { FC } from 'react';

import { LocationObject } from 'src/general/components/SetLocationPopup/EnterLocationScreen/SetLocation/SetLocation.types';

import { PopUpTitle } from '../PopUpTitle/PopUpTitle';
import { SetLocationPopupMicrocopyProps } from '../SetLocationPopup.types';
import { DeliveryOptions } from './DeliveryOptions/DeliveryOptions';
import { EditLocation } from './EditLocation/EditLocation';
import { EnterEmail } from './EnterEmail/EnterEmail';
import styles from './HandoverOptionsScreen.module.scss';
import { PickupOptions } from './PickupOptions/PickupOptions';

export type HandoverOptionsScreenProps = {
  onClose: () => void;
  onEditLocation: () => void;
  location: LocationObject;
  microcopy: SetLocationPopupMicrocopyProps;
};

export const HandoverOptionsScreen: FC<HandoverOptionsScreenProps> = ({
  onClose,
  onEditLocation,
  location,
  microcopy,
}) => {
  const { titleDeliveryCollection, placeholder, submitButton, successMessage, locationHeader, locationFooter } =
    microcopy;

  const pickupOnly = !location.can_deliver && location.can_pickup;
  const noDeliveryOrPickup = !location.can_deliver && !location.can_pickup;

  return (
    <>
      <PopUpTitle title={titleDeliveryCollection} onClose={onClose} />
      <div className={styles.purpleBox}>
        <EditLocation
          onEdit={onEditLocation}
          location={location}
          locationHeader={locationHeader}
          locationFooter={locationFooter}
          emailInput={null}
        />
        {pickupOnly && (
          <div className={styles.email}>
            <DeliveryOptions deliverable={false} microcopy={microcopy} />
            <EnterEmail
              location={location}
              placeholder={placeholder}
              submitButton={submitButton}
              successMessage={successMessage}
            />
          </div>
        )}
      </div>
      {location.can_deliver && <DeliveryOptions deliverable microcopy={microcopy} />}
      <PickupOptions microcopy={microcopy} canPickup={!noDeliveryOrPickup} location={location} />
    </>
  );
};
